<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0001 22.0001C6.49151 22.0001 2 17.5086 2 12.0001C2 6.49151 6.49151 2 12.0001 2C17.5086 2 22.0001 6.49151 22.0001 12.0001C22.0001 17.5086 17.5086 22.0001 12.0001 22.0001Z"
      fill="currentColor"
    />
    <path d="M13.0001 16V18.0001H11V16H13.0001Z" fill="white" />
    <path d="M13.0001 6V14H11V6H13.0001Z" fill="white" />
  </svg>
</template>
